import { Component, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MenuItem } from 'primeng/api';
import { IndicatorsSearchToolbarModel } from '../../../models/indicators-search-toolbar-model.model';
import { SearchToolbarFactoryParameters, SearchToolbarSection } from '../../../models/search-toolbar-factory-parameters.model';
import { AnalyticsService } from '../../../services/analytics/analytics.service';
import { SearchToolbarModelFactoryService } from '../../../services/search-toolbar-model-factory/search-toolbar-model-factory.service';
import { ContactableChannelComponent } from './contactable-channel/contactable-channel.component';
import { ContactableConsentComponent } from './contactable-consent/contactable-consent.component';
import { ContactableMainKpiComponent } from './contactable-main-kpi/contactable-main-kpi.component';

@Component({
    selector: 'app-customers-contactable',
    templateUrl: './customers-contactable.component.html',
    styleUrls: ['./customers-contactable.component.css']
})

//Pagina 9 - Pagina 10 - Pagina 11
export class CustomersContactableComponent implements OnInit {
    @ViewChild(ContactableMainKpiComponent) mainKpi: ContactableMainKpiComponent;
    @ViewChild(ContactableChannelComponent) contactChanel: ContactableChannelComponent;
    @ViewChild(ContactableConsentComponent) consent: ContactableConsentComponent;
    public searchModel: IndicatorsSearchToolbarModel = new IndicatorsSearchToolbarModel();
    oldData: any;

    public items: MenuItem[];
    public activeIndex: number;
    public translations: any;

    constructor(private translate: TranslateService,
                private svcAnalytics: AnalyticsService,
                private searchModelFactory: SearchToolbarModelFactoryService) {
    }

    ngOnInit() {
        this.activeIndex = 0;
        this.items = [];
        this.translations = {};

        this.translate.get([
            'contactable.title',
            'contactable.mainKpi',
            'contactable.contactChannel',
            'contactable.consent'
        ]).subscribe(t => {
            const searchParams: SearchToolbarFactoryParameters = new SearchToolbarFactoryParameters();
            searchParams.svcAnalytics = this.svcAnalytics;
            searchParams.disabledSections = [SearchToolbarSection.CardModes];

            this.searchModelFactory.buildSearchToolbarModel(searchParams).subscribe((model) => {
                this.searchModel = model;
            });

            this.translations = {
                title: t['contactable.title']
            };

            this.items.push(
                {
                    label: t['contactable.mainKpi'],
                    command: (event: any) => {
                        this.activeIndex = 0;
                    }
                },
                {
                    label: t['contactable.contactChannel'],
                    command: (event: any) => {
                        this.activeIndex = 1;
                    }
                },
                {
                  label: t['contactable.consent'],
                  command: (event: any) => {
                    this.activeIndex = 2;
                  }
                }
            );
        });
    }

    ApplyResult (data) {
        const isDataEquals = JSON.stringify(this.oldData) === JSON.stringify(data);

        switch (this.activeIndex) {
            case 0:
                if (!isDataEquals) {
                    this.contactChanel.resetData();
                    this.consent.resetData();
                }
                this.mainKpi.searchValue(data);
                break;
            case 1:
                if (!isDataEquals) {
                    this.mainKpi.resetData();
                    this.consent.resetData();
                }

                this.contactChanel.searchValue(data);
                break;
            case 2:
                if (!isDataEquals) {
                    this.mainKpi.resetData();
                    this.contactChanel.resetData();
                }

                this.consent.searchValue(data);
                break;
        }

        this.oldData = { ...data };
    }


}



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customers-contactable/customers-contactable.component.ts